module.exports = __webpack_public_path__ + "static/39-2838572aa538cd370423a9a55d45d4b0.png";